import React, { useEffect, useState } from 'react';
import { Eye, EyeOff, X, ArrowLeft } from 'lucide-react';
import { dataService } from '../../../Services/data/data.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Grid2, TextField, Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputAdornment, IconButton } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, sendEmailVerification, sendPasswordResetEmail, RecaptchaVerifier, GoogleAuthProvider, multiFactor, TotpMultiFactorGenerator, TotpSecret, getMultiFactorResolver } from "firebase/auth";
import { toast } from 'react-toastify';
import QRCode from "qrcode.react";
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";
import { authViews } from '../../../Config/constants';
import Button from '../../Shared/Buttons/Button';

toast.configure();

function LoginPage(props) {
    const classes = useStyles();
    const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

    // AuthNavigation
    const [currentAuthView, setCurrentAuthView] = useState(authViews.LOGIN);

    // URL parameter
    const [searchParams] = useSearchParams();
    const register = searchParams.get("register"); // Used to link directly to register tab


    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const [email, setEmail] = useState("");
    const [company, setCompany] = useState("");
    // const [phoneNumber, setPhoneNumber] = useState();

    const [lastName, setLastName] = useState("");
    const [firstName, setFirstName] = useState("");
    const [password, setPassword] = useState("");
    const [emailAlreadyUsed] = useState(false);
    // const appVerifier = window.recaptchaVerifier;
    const [captchaValue, setCaptcha] = useState(null);
    const [imageNumber, setImageNumber] = useState(1);
    const navigate = useNavigate();
    const [verificationMessage] = useState(false);
    const [recaptchaRequired, setRecaptchaRequired] = useState(false);
    const [open, setOpen] = useState(false);
    // const [recaptchaKey, setRecaptchaKey] = useState(null);

    // Validation
    const [successMessage, setSuccessMessage] = useState("");
    const [generalError, setGeneralError] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [companyError, setCompanyError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);

    // Multi factor
    const [totpSecret, setTotpSecret] = useState(null);
    const [totpQrCodeUrl, setTotpQrCodeUrl] = useState(null);
    const [verificationCode, setVerificationCode] = useState("");
    const [verificationCodeError, setVerificationCodeError] = useState(false);
    const [mfaResolverUid, setMfaResolverUid] = useState(null);
    const [authError, setAuthError] = useState(null);

    const [submittingForm, setSubmittingForm] = useState(false);

    let auth = getAuth();

    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        var min = 1;
        var max = 3;
        var number = Math.floor(Math.random() * (max - min + 1) + min);
        setImageNumber(number);
    }, [])
    const recaptchaRef = React.createRef();

    const checkLogin = (e) => {
        e.preventDefault();
        setSubmittingForm(true);

        resetErrors();
        if (email === "" || password === "") {
            if (email === "") {
                setEmailError(true);
            }
            if (password === "") {
                setPasswordError(true);
            }
            setSubmittingForm(false);
        } else {
            // Sign in with email and pass.
            signInWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    // Signed in 
                    const user = userCredential.user;
                    const userToken = user.accessToken;
                    if (user) {
                        if (user.emailVerified) {
                            handleMultiFactorEnrollment(user);
                            // dataService.getUserByEmailAddress(user.email, userToken).then(results => {
                            //     if (results) {
                            //         props.actions.setUserid(results.id);
                            //         props.actions.setUserName(results.firstname);
                            //         props.actions.setLastName(results.lastname);
                            //         props.actions.setCompanyIds(results.companyIds);
                            //         props.actions.setUserToken(userToken);
                            //         props.actions.setUserRoles(results.roleIds);
                            //         props.actions.setEmail(user.email);

                            //         // User is signed in, see docs for a list of available properties
                            //         // https://firebase.google.com/docs/reference/js/firebase.User
                            //         props.actions.setLogin(true);
                            //         navigate("/");
                            //     }
                            // }).catch((error) => {
                            //     console.log('error', error)
                            // });

                        } else {
                            setOpen(true);
                        }

                    } else {

                    }
                }).catch((error) => {
                    if (error.code === "auth/multi-factor-auth-required") {
                        setAuthError(error);
                        const mfaResolver = getMultiFactorResolver(getAuth(), error);
                        setMfaResolverUid(mfaResolver.hints[0].uid);
                        handleAuthNavigation(authViews.TOTPSIGNIN);
                    } else {
                        setGeneralError("Failed to sign in. Please check your credentials.");
                    }
                }).finally(() => {
                    setSubmittingForm(false);
                });
        }
    }

    const handleMultiFactorEnrollment = async (user) => {
        const multiFactorSession = await multiFactor(user).getSession();
        const totpSecret = await TotpMultiFactorGenerator.generateSecret(
            multiFactorSession
        );

        let qrCodeUrl = totpSecret.generateQrCodeUrl(user.email, "Taplr");

        setTotpSecret(totpSecret);
        setTotpQrCodeUrl(qrCodeUrl);

        handleAuthNavigation(authViews.TWOFACTORENROLLMENT);
    };

    const checkRegister = (e) => {
        e.preventDefault();
        setSubmittingForm(true);
        const recaptchaAuth = getAuth();
        window.recaptchaVerifier = new RecaptchaVerifier('register-button', {
            'size': 'invisible',
            'callback': (response) => {
                console.log(response);
                // reCAPTCHA solved, allow signInWithPhoneNumber.
            }
        }, recaptchaAuth);

        resetErrors();
        if (email === "" || firstName === "" || lastName === "" || company === "") {
            if (email === "") {
                setEmailError(true);
            }
            if (firstName === "") {
                setFirstNameError(true);
            }
            if (lastName === "") {
                setLastNameError(true);
            }
            if (company === "") {
                setCompanyError(true);
            }
            if (captchaValue === null) {
                setRecaptchaRequired(true);
            }
            setSubmittingForm(false);
        } else {
            if (captchaValue !== null) {
                setRecaptchaRequired(false);

                dataService.requestLogin(firstName, lastName, company, email).then(response => {
                    if (response.success === true) {
                        setCaptcha(null);
                        setSuccessMessage("Your account request has been received. We've sent a confirmation email to your address.");
                    } else {
                        setCaptcha(null);
                        setGeneralError("Something went wrong, please try again.");
                    }
                }).finally(() => {
                    setSubmittingForm(false);
                });;

            } else {
                setRecaptchaRequired(true);
                setSubmittingForm(false);
            }
        }
    }

    const resetErrors = () => {
        setGeneralError("");
        setSuccessMessage("");

        setEmailError(false);
        setCompanyError(false);
        setPasswordError(false);
        setFirstNameError(false);
        setLastNameError(false);
    }

    const handleVerificationMail = (event) => {
        setOpen(false);
        let auth = getAuth();

        if (email === "") {
            setEmailError(true);
        } else {
            sendEmailVerification(auth.currentUser)
                .then(() => {
                    // Email verification sent!
                    // ...
                });
        }


    }
    const sendPasswordMail = (event) => {
        event.preventDefault();
        setSubmittingForm(true);

        resetErrors();
        if (email === "") {
            setEmailError(true);
        } else {
            sendPasswordResetEmail(auth, email)
                .then(() => {
                    setSuccessMessage("An email has been sent to: " + email);
                }).catch((error) => {
                    const errorMessage = error.message;
                    setGeneralError(errorMessage);
                }).finally(() => {
                    setSubmittingForm(false);
                });
        }
    }

    const handleAuthNavigation = (authView) => {
        if (currentAuthView === authViews.REGISTER) {
            setEmail("");
            setPassword("");
            setFirstName("");
            setLastName("");
        };
        resetErrors();
        setCurrentAuthView(authView);
    };

    // Navigate straight to sign up tab
    const handleSignUp = () => {
        resetErrors();
        setPassword("");

    }

    // Checks if the user should be directed to the sign up tab
    useEffect(() => {
        if (register === "true") {
            handleAuthNavigation(authViews.REGISTER);
        }
    }, [register]);

    const navigateToHomePage = () => {
        navigate("/");
    }

    const changeEmail = (event) => {
        setEmail(event.target.value);
    };

    const changeCompany = (event) => {
        setCompany(event.target.value);
    };

    const changeVerificationCode = (event) => {
        setVerificationCode(event.target.value);
    };

    const changeLastName = (event) => {
        setLastName(event.target.value);
    }

    const changeFirstName = (event) => {
        setFirstName(event.target.value);
    };

    const changePassword = (event) => {
        setPassword(event.target.value);
    };

    const handleCaptcha = (value) => {
        setCaptcha(value);
    }

    const finalizeMfaEnrollment = async (event) => {
        event.preventDefault();
        setSubmittingForm(true);

        const multiFactorAssertion = TotpMultiFactorGenerator.assertionForEnrollment(totpSecret, verificationCode);
        await multiFactor(auth.currentUser).enroll(multiFactorAssertion, "Authenticator App").then(result => {
            if (auth.currentUser) {
                dataService.getUserByEmailAddress(auth.currentUser.email, auth.currentUser.accessToken).then(results => {
                    if (results) {
                        if (results) {
                            props.actions.setUserid(results.id);
                            props.actions.setUserName(results.firstname);
                            props.actions.setLastName(results.lastname);
                            props.actions.setCompanyIds(results.companyIds);
                            props.actions.setUserToken(auth.currentUser.accessToken);
                            props.actions.setUserRoles(results.roleIds);
                            props.actions.setEmail(auth.currentUser.email);
                            props.actions.setLogin(true);
                            props.actions.resetActiveFilters();
                            if (results.subscriberUniqueId !== null) {
                                props.actions.setSubscriberUniqueId(results.subscriberUniqueId);
                            } else {
                                props.actions.setSubscriberUniqueId(null);
                            }
                            props.actions.setIsSubscriberAdmin(results.isSubscriberAdmin);
                            props.actions.setIsTaplrAdmin(results.isTaplrAdmin);
                            navigate("/");
                        }
                    } else {
                        handleAuthNavigation(authViews.LOGIN);
                    }
                }).catch((error) => {
                    console.log('error', error)
                }).finally(() => {
                    setSubmittingForm(false);
                });
            } else {
                handleAuthNavigation(authViews.LOGIN);
                setSubmittingForm(false);
            }
        }).catch((error) => {
            console.log(error);
            setGeneralError("The verification code you provided has expired or is not valid.");
        }).finally(() => {
            setSubmittingForm(false);
        });
    };

    const loginWithTotp = async (event) => {
        event.preventDefault();
        setSubmittingForm(true);

        const otpFromAuthenticator = verificationCode;
        const multiFactorAssertion = TotpMultiFactorGenerator.assertionForSignIn(mfaResolverUid, otpFromAuthenticator);
        const mfaResolver = getMultiFactorResolver(getAuth(), authError);

        try {
            const userCredential = await mfaResolver.resolveSignIn(multiFactorAssertion);
            const user = userCredential.user;
            const userToken = user.accessToken;
            if (user) {
                if (user.emailVerified) {
                    dataService.getUserByEmailAddress(user.email, userToken).then(results => {
                        if (results) {
                            props.actions.setUserid(results.id);
                            props.actions.setUserName(results.firstname);
                            props.actions.setLastName(results.lastname);
                            props.actions.setCompanyIds(results.companyIds);
                            props.actions.setUserToken(userToken);
                            props.actions.setUserRoles(results.roleIds);
                            if (results.subscriberUniqueId !== null) {
                                props.actions.setSubscriberUniqueId(results.subscriberUniqueId);
                            } else {
                                props.actions.setSubscriberUniqueId(null);
                            }
                            props.actions.setIsSubscriberAdmin(results.isSubscriberAdmin);
                            props.actions.setIsTaplrAdmin(results.isTaplrAdmin);
                            props.actions.setEmail(user.email);
                            props.actions.setLogin(true);
                            props.actions.resetActiveFilters();
                            navigate("/");
                        }
                    }).catch((error) => {
                        console.log('error', error)
                    }).finally(() => {
                        setSubmittingForm(false);
                    });
                } else {
                    setOpen(true);
                }

            } else {

            }
        } catch (error) {
            console.log(error);
            setGeneralError("The verification code you provided has expired or is not valid.");
            setSubmittingForm(false);
        }
    };

    return (
        <div className={classes.loginContainer}>
            <div className={classes.imageContainer}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/images/Login/istock' + imageNumber + '.jpg'})` }}>
                <div className={classes.imageOverlay}>

                </div>
            </div>

            {currentAuthView === authViews.LOGIN ?
                <form onSubmit={checkLogin} className={classes.loginForm}>

                    <div className={classes.logoContainer}>
                        <img className={classes.logoContainer__logo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} onClick={() => navigateToHomePage()} alt="Taplr Logo"></img>
                    </div>
                    <div className={classes.login}>
                        <h1 className={classes.actionType}>Sign in</h1>
                        {generalError !== "" &&
                            <div className={classes.generalErrorContainer}>
                                <p className={classes.generalErrorText}>{generalError}</p>
                            </div>
                        }
                        <div className={classes.form__column}>
                            <div className={classes.form__inputContainer}>
                                <label className={classes.form__label} style={{ color: emailError ? "#D84949" : "#0C0E29" }}>{emailError ? "Email address is required" : "Email address"}</label>
                                <input className={classes.form__input} autoFocus style={{ borderColor: emailError ? "#D84949" : "#A9A9A9" }} type="email" value={email} onChange={(event) => changeEmail(event)} />
                            </div>
                            <div className={classes.form__inputContainer}>
                                <label className={classes.form__label} style={{ color: passwordError ? "#D84949" : "#0C0E29" }}>{passwordError ? "Password is required" : "Password"}</label>
                                <div className={classes.form__passwordInputContainer}>
                                    <input className={classes.form__passwordInput} style={{ borderColor: passwordError ? "#D84949" : "#A9A9A9" }} type={showPassword ? "text" : "password"} value={password} onChange={(event) => changePassword(event)} />
                                    <button type="button" onClick={handleClickShowPassword} className={classes.form__showPasswordButton}>
                                        {showPassword ?
                                            <EyeOff size={20} strokeWidth={1.4} color="#0C0E29" />
                                            :
                                            <Eye size={20} strokeWidth={1.4} color="#0C0E29" />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                        <Button type="submit" loading={submittingForm} variant='primary' fullWidth>Sign in</Button>
                        <button type="button" className={classes.forgotPasswordButton} style={{ marginTop: '16px' }} onClick={() => handleAuthNavigation(authViews.FORGOTPASSWORD)}>Forgot Password?</button>
                        <div className={classes.dividerWithText}>
                            <div className={classes.dividerLine} />
                            <span className={classes.dividerText}>New to Taplr?</span>
                            <div className={classes.dividerLine} />
                        </div>
                        <Button type="button" variant='outlined' fullWidth onClick={() => handleAuthNavigation(authViews.REGISTER)}>Request an account</Button>
                        {verificationMessage ?
                            <div>
                                <p>A verification e-mail was sent to {email}, please verify your account before using our app.</p>
                                <a href="/#" onClick={() => handleVerificationMail()}>Resend the mail?</a>
                            </div>

                            : <React.Fragment></React.Fragment>
                        }

                    </div>
                </form>
                :
                currentAuthView === authViews.FORGOTPASSWORD ?
                    <div className={classes.loginForm}>
                        <div className={classes.logoContainer}>
                            <img className={classes.logoContainer__logo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} onClick={() => navigateToHomePage()} alt="Taplr Logo"></img>
                        </div>
                        <div className={classes.login}>
                            <h1 className={classes.actionType}>Forgot password</h1>
                            <>
                                {generalError !== "" &&
                                    <div className={classes.generalErrorContainer}>
                                        <p className={classes.generalErrorText}>{generalError}</p>
                                    </div>
                                }
                            </>
                            <>
                                {successMessage !== "" &&
                                    <div className={classes.successContainer}>
                                        <p className={classes.successText}>{successMessage}</p>
                                    </div>
                                }
                            </>
                            <form onSubmit={sendPasswordMail}>
                                <div className={classes.form__column}>
                                    <div className={classes.form__inputContainer}>
                                        <label className={classes.form__label} style={{ color: emailError ? "#D84949" : "#0C0E29" }}>{emailError ? "Email address is required" : "Email address"}</label>
                                        <input className={classes.form__input} autoFocus style={{ borderColor: emailError ? "#D84949" : "#A9A9A9" }} type="email" value={email} onChange={(event) => changeEmail(event)} />
                                    </div>
                                </div>
                                <Button type="submit" variant='primary' loading={submittingForm} fullWidth>Send email</Button>
                            </form>
                            <button type="button" onClick={() => handleAuthNavigation(authViews.LOGIN)} className={classes.backButton}>
                                <ArrowLeft className={classes.backButton__icon} />
                                Back to sign in
                            </button>
                        </div>
                    </div>
                    : currentAuthView === authViews.REGISTER ?

                        <form onSubmit={checkRegister} className={classes.loginForm}>
                            <div className={classes.logoContainer}>
                                <img className={classes.logoContainer__logo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} onClick={() => navigateToHomePage()} alt="Taplr Logo"></img>
                            </div>
                            <div className={classes.login}>
                                <h1 className={classes.actionType}>Request an account</h1>
                                <>
                                    {generalError !== "" &&
                                        <div className={classes.generalErrorContainer}>
                                            <p className={classes.generalErrorText}>{generalError}</p>
                                        </div>
                                    }
                                </>
                                <>
                                    {successMessage !== "" &&
                                        <div className={classes.successContainer}>
                                            <p className={classes.successText}>{successMessage}</p>
                                        </div>
                                    }
                                </>
                                <div className={classes.form__column}>
                                    <div className={classes.form__row}>
                                        <div className={classes.form__inputContainer}>
                                            <label className={classes.form__label} style={{ color: firstNameError ? "#D84949" : "#0C0E29" }}>{firstNameError ? "First name is required" : "First name"}</label>
                                            <input className={classes.form__input} autoFocus style={{ borderColor: firstNameError ? "#D84949" : "#A9A9A9" }} type="text" value={firstName} onChange={(event) => changeFirstName(event)} />
                                        </div>
                                        <div className={classes.form__inputContainer}>
                                            <label className={classes.form__label} style={{ color: lastNameError ? "#D84949" : "#0C0E29" }}>{lastNameError ? "Last name is required" : "Last name"}</label>
                                            <input className={classes.form__input} style={{ borderColor: lastNameError ? "#D84949" : "#A9A9A9" }} type="text" value={lastName} onChange={(event) => changeLastName(event)} />
                                        </div>
                                    </div>
                                    <div className={classes.form__inputContainer}>
                                        <label className={classes.form__label} style={{ color: companyError ? "#D84949" : "#0C0E29" }}>{companyError ? "Company is required" : "Company"}</label>
                                        <input className={classes.form__input} style={{ borderColor: companyError ? "#D84949" : "#A9A9A9" }} type="text" value={company} onChange={(event) => changeCompany(event)} />
                                    </div>
                                    <div className={classes.form__inputContainer}>
                                        <label className={classes.form__label} style={{ color: emailError ? "#D84949" : "#0C0E29" }}>{emailError ? "Email address is required" : "Email address"}</label>
                                        <input className={classes.form__input} style={{ borderColor: emailError ? "#D84949" : "#A9A9A9" }} type="email" value={email} onChange={(event) => changeEmail(event)} />
                                    </div>
                                </div>
                                {emailAlreadyUsed ? <b style={{ color: 'red' }}>This email address is already in use.</b> : <React.Fragment></React.Fragment>}
                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
                                    <ReCAPTCHA style={recaptchaRequired ? { border: 'red 1px solid' } : { border: 'none' }}
                                        ref={recaptchaRef}
                                        sitekey={recaptchaKey}
                                        onChange={(e) => handleCaptcha(e)}
                                    />
                                </div>
                                {recaptchaRequired ? <p style={{ color: 'red' }}>Recaptcha is required</p> : <React.Fragment></React.Fragment>}
                                <Button type="submit" variant='primary' fullWidth disabled={!captchaValue} loading={submittingForm} id='register-button'>Request an account</Button>
                                <div className={classes.dividerWithText}>
                                    <div className={classes.dividerLine} />
                                    <span className={classes.dividerText}>Already have an account?</span>
                                    <div className={classes.dividerLine} />
                                </div>
                                <Button type="button" variant='outlined' fullWidth onClick={() => handleAuthNavigation(authViews.LOGIN)}>Sign in</Button>
                            </div>
                        </form>
                        : currentAuthView === authViews.TWOFACTORENROLLMENT ?
                            <div className={classes.loginForm}>
                                <div className={classes.logoContainer}>
                                    <img className={classes.logoContainer__logo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} onClick={() => navigateToHomePage()} alt="Taplr Logo"></img>
                                </div>
                                <div className={classes.login}>
                                    <h1 className={classes.actionType}>Multi-factor authentication</h1>
                                    <p className={classes.subtitle}>Add an extra layer of security to protect your account from unauthorized access.</p>
                                    <>
                                        {generalError !== "" &&
                                            <div className={classes.generalErrorContainer}>
                                                <p className={classes.generalErrorText}>{generalError}</p>
                                            </div>
                                        }
                                    </>
                                    <>
                                        {successMessage !== "" &&
                                            <div className={classes.successContainer}>
                                                <p className={classes.successText}>{successMessage}</p>
                                            </div>
                                        }
                                    </>
                                    <div className={classes.qrCodeContainer}>
                                        <QRCode
                                            id="Qr"
                                            value={totpQrCodeUrl}
                                            bgColor={"#ffffff"}
                                            renderAs={"svg"}
                                            size={160} />
                                        <p>{totpSecret.secretKey}</p>
                                    </div>
                                    <form onSubmit={finalizeMfaEnrollment}>
                                        <div className={classes.form__column}>
                                            <div className={classes.form__inputContainer}>
                                                <label className={classes.form__label} style={{ color: verificationCodeError ? "#D84949" : "#0C0E29" }}>{verificationCodeError ? "Verification code is required" : "Verification code"}</label>
                                                <input className={classes.form__input} autoFocus style={{ borderColor: verificationCodeError ? "#D84949" : "#A9A9A9" }} type="text" value={verificationCode} onChange={(event) => changeVerificationCode(event)} />
                                            </div>
                                        </div>
                                        <Button type="submit" fullWidth loading={submittingForm}>Submit</Button>
                                    </form>
                                    <button type="button" onClick={() => handleAuthNavigation(authViews.LOGIN)} className={classes.backButton}>
                                        <ArrowLeft className={classes.backButton__icon} />
                                        Back to sign in
                                    </button>
                                </div>
                            </div>
                            : currentAuthView === authViews.TOTPSIGNIN ?
                                <div className={classes.loginForm}>
                                    <div className={classes.logoContainer}>
                                        <img className={classes.logoContainer__logo} src={process.env.PUBLIC_URL + "/images/Taplr.png"} onClick={() => navigateToHomePage()} alt="Taplr Logo"></img>
                                    </div>
                                    <div className={classes.login}>
                                        <h1 className={classes.actionType}>Multi-factor authentication</h1>
                                        <p className={classes.subtitle}>Check your authenticator app for a verification code.</p>
                                        <>
                                            {generalError !== "" &&
                                                <div className={classes.generalErrorContainer}>
                                                    <p className={classes.generalErrorText}>{generalError}</p>
                                                </div>
                                            }
                                        </>
                                        <>
                                            {successMessage !== "" &&
                                                <div className={classes.successContainer}>
                                                    <p className={classes.successText}>{successMessage}</p>
                                                </div>
                                            }
                                        </>
                                        <form onSubmit={loginWithTotp}>
                                            <div className={classes.form__column}>
                                                <div className={classes.form__inputContainer}>
                                                    <label className={classes.form__label} style={{ color: verificationCodeError ? "#D84949" : "#0C0E29" }}>{verificationCodeError ? "Verification code is required" : "Verification code"}</label>
                                                    <input className={classes.form__input} autoFocus style={{ borderColor: verificationCodeError ? "#D84949" : "#A9A9A9" }} type="text" value={verificationCode} onChange={(event) => changeVerificationCode(event)} />
                                                </div>
                                            </div>
                                            <Button type="submit" variant='primary' loading={submittingForm} fullWidth>Sign in</Button>
                                        </form>
                                        <button type="button" onClick={() => handleAuthNavigation(authViews.LOGIN)} className={classes.backButton}>
                                            <ArrowLeft className={classes.backButton__icon} />
                                            Back to sign in
                                        </button>
                                    </div>
                                </div> : <React.Fragment></React.Fragment>}

            <Dialog
                className={classes.dialog}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{ paper: classes.dialogPaper }}
            >
                <div className={classes.dialog__head}>
                    <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                        Verify your email address
                    </DialogTitle>
                    <button onClick={() => handleClose()} className={classes.dialog__closeButton}>
                        <X size={19} />
                    </button>
                </div>
                <DialogContent className={classes.dialog__contentContainer}>
                    <div className={classes.dialog__content}>
                        <p className={classes.dialog__subtitle}>Your email address has not been verified yet. Please check your inbox.</p>
                    </div>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', flexDirection: "column", gap: "8px", justifyContent: 'space-between', paddingLeft: '16px', paddingRight: '16px', paddingBottom: "16px" }}>
                    <button onClick={() => handleVerificationMail()} variant="contained" className={classes.primaryButton}>
                        Resend mail
                    </button>
                </DialogActions>
            </Dialog>
        </div>

    )
}

export default LoginPage;

const useStyles = makeStyles((theme) => ({

    loginForm: {
        backgroundColor: 'transparent',
        height: '100vh',
        [theme.breakpoints.up('sm')]: {
            width: '45%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        gap: "16px",
    },

    loginContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
    },

    imageContainer: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },

        backgroundColor: "#e6ccb1",
        width: '55%',
        maxWidth: '100%',
        maxHeight: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative'
    },

    imageOverlay: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        backgroundColor: 'black',
        opacity: '0.6',
    },

    logoContainer: {
        width: "70%",
        maxWidth: "480px",
        margin: "0px auto",

        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        backgroundColor: "var(--color-primary)",
        border: "1px solid var(--color-primary-dark)",

        borderRadius: "8px",

        boxShadow: "2px 4px 12px 0px rgb(175 175 175 / 40%)",

        padding: "16px",

        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 32px)',
            margin: "0px auto",
        },
    },

    logoContainer__logo: {
        height: "56px",
        width: "auto",

        "&:hover": {
            cursor: "pointer",
        },
    },

    login: {
        height: 'auto',
        width: '70%',
        maxWidth: "480px",

        position: 'relative',

        display: "flex",
        flexDirection: 'column',

        backgroundColor: "white",
        outline: "1px solid #EDEDED",
        boxShadow: '2px 4px 12px 0px rgb(175 175 175 / 40%)',

        borderRadius: "8px",

        color: "#0C0E29 !important",

        margin: "0px auto",
        padding: "16px",

        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 32px)',
            margin: "0px auto",
        },
    },

    actionType: {
        marginBottom: "16px",
    },

    subtitle: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "normal",

        color: "#0C0E29",
        opacity: "0.8",

        marginBottom: "16px",
    },

    generalErrorContainer: {
        width: "100%",

        border: "1px solid #FBE5E5",
        borderRadius: "6px",

        backgroundColor: "#FDF3F3",

        padding: "12px",
        marginBottom: "16px",
    },

    generalErrorText: {
        fontSize: "16px",
        color: "#D84949",
    },

    successContainer: {
        width: "100%",

        border: "1px solid #E2F8E0",
        borderRadius: "6px",

        backgroundColor: "#F3FBF2",

        padding: "12px",
        marginBottom: "16px",
    },

    successText: {
        fontSize: "16px",
        color: "#3AB037",
    },

    qrCodeContainer: {
        width: "100%",

        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",

        border: "1px solid #EDEDED",
        borderRadius: "8px",

        marginBottom: "16px",
        padding: "16px",
    },

    form__column: {
        width: "100%",
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',

        marginBottom: "24px",
    },

    form__row: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
    },

    form__inputContainer: {
        width: '100%',

        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },

    form__label: {
        fontSize: '14px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',
        color: "#0C0E29",
    },

    form__input: {
        width: '100%',
        height: '40px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        paddingLeft: '8px',
        boxSizing: 'border-box',

        overflow: "hidden",

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    form__passwordInputContainer: {
        position: 'relative',
    },

    form__passwordInput: {
        width: '100%',
        height: '40px',
        borderRadius: '3px',
        border: '1px solid #A9A9A9',

        padding: '0px 8px',
        paddingLeft: '8px',
        boxSizing: 'border-box',

        overflow: "hidden",

        fontSize: '16px',
        fontFamily: 'Lato, sans-serif !important',
        fontWeight: 'regular',
        color: '#0C0E29',

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        },
    },

    form__showPasswordButton: {
        height: "32px",
        width: "32px",
        borderRadius: "4px",

        backgroundColor: "transparent",

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '4px',

        cursor: 'pointer',
        border: 'none',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#EDEDED',
        },
    },

    dividerWithText: {
        width: "100%",

        display: "flex",
        alignItems: "center",
        gap: "8px",

        margin: "16px 0",
    },

    dividerLine: {
        width: "100%",
        height: "1px",
        backgroundColor: "#989898",
    },

    dividerText: {
        whiteSpace: "nowrap",
        fontSize: "14px",
        color: "#989898",
    },

    primaryButton: {
        height: "40px",
        width: "100%",
        padding: "0 16px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        transition: "all 0.2s ease-in-out",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            cursor: "pointer",
        }
    },

    disabled: {
        backgroundColor: "#DCDCDC",
        color: "#989898",

        "&:hover": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "default",
        },
    },

    secondaryButton: {
        height: "40px",
        padding: "0 16px",

        border: "1px solid var(--color-primary)",
        borderRadius: "4px",

        fontSize: "16px",
        color: "var(--color-primary)",
        backgroundColor: "transparent",

        transition: "all 0.2s ease-in-out",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            border: "1px solid #a77d4f",
            cursor: "pointer",
        }
    },

    forgotPasswordButton: {
        fontSize: '14px',
        cursor: 'pointer',
        color: "#0C0E29",
        opacity: "0.8",

        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        padding: "0px",
        margin: "0 auto",

        transition: "opacity 0.2s ease-in-out",

        "&:hover": {
            opacity: "1",
        },
    },

    backButton: {
        display: "flex",
        alignItems: "center",
        gap: "4px",

        fontSize: '14px',
        cursor: 'pointer',
        color: "#0C0E29",
        opacity: "0.8",

        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        padding: "0px",
        margin: "16px auto 8px auto",

        transition: "opacity 0.1s ease-in-out",

        "&:hover": {
            opacity: "1",
        },
    },

    backButton__icon: {
        height: "16px",
        width: "16px",

        transition: "all 0.1s ease-in-out",

        color: "inherit",
        opacity: "inherit",
    },

    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        width: '480px !important',
        height: 'auto',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus-visible': {
            outline: '#4654FB auto 1px',
        },
    },

    dialog__subtitle: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: '#0C0E29',

        margin: '0px 0px 16px 0px',
    },

    dialog__contentContainer: {
        padding: '0px 16px !important',
        marginBottom: "16px",

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },
}));